import React from 'react';
import SelectIcon from '../../../../assets/icons/SelectIcon';
import { Option, SuggestionsContainer, CheckMarkWrapper } from './Search.style';
import { FilterOption } from '../../../../types';

type SuggestionsListProps = {
  suggestions: FilterOption[];
  focusedOptionIndex: number;
  setFocusedOptionIndex: (value: React.SetStateAction<number>) => void;
  handleSuggestionClick: (suggestion: string) => void;
};

const SuggestionsList: React.FC<SuggestionsListProps> = ({
  suggestions,
  focusedOptionIndex,
  setFocusedOptionIndex,
  handleSuggestionClick,
}) => (
  <SuggestionsContainer>
    {suggestions.map((model, index) => (
      <Option
        key={model.value}
        focused={index === focusedOptionIndex}
        onMouseOver={() => setFocusedOptionIndex(index)}
        onClick={() => handleSuggestionClick(model.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleSuggestionClick(model.value);
          }
        }}
      >
        <CheckMarkWrapper focused={index === focusedOptionIndex}>
          <SelectIcon />
        </CheckMarkWrapper>
        <span>{model.label}</span>
      </Option>
    ))}
  </SuggestionsContainer>
);

export default SuggestionsList;
